import { SharedPriority } from "../data/RelationshipPrioritiesDataSource";

export const SharedPrioritiesPanel = ({
  priorities,
  isToday,
  onView,
}: {
  priorities: SharedPriority[];
  isToday: boolean;
  onView: () => void;
}) => {
  if (!priorities.length) return null;
  return (
    <section className="mb-3 border-t border-grayLight px-3 pt-4">
      <h3 className="font-bold text-black">
        {isToday ? "Today's meaningful introduction" : "Priorities you share"}
      </h3>
      <div className="mt-2 flex flex-wrap gap-2">
        {priorities.slice(0, 3).map((priority) => (
          <span
            key={priority.key}
            className="rounded-lg bg-primary/10 px-2.5 py-1 text-sm font-semibold text-primary"
          >
            {priority.label}
          </span>
        ))}
      </div>
      <p className="mt-2 text-sm text-graySecondary">
        See why you may connect before deciding.
      </p>
      <button
        type="button"
        onClick={onView}
        className="mt-3 w-full rounded-lg border border-primary px-4 py-2.5 font-semibold text-primary hover:bg-primary/5"
      >
        {isToday ? "View today's introduction" : "View shared priorities"}
      </button>
    </section>
  );
};
